export const setSalutationAction = (payload) => {
    return {
        type: "salutation",
        payload
    }
};

export const setFirstNameAction = (payload) => {
    return {
        type: "firstName",
        payload
    }
};

export const setSurnameAction = (payload) => {
    return {
        type: "surname",
        payload
    }
};

export const setEmailAction = (payload) => {
    return {
        type: "email",
        payload
    }
};

export const setLandAction = (payload) => {
    return {
        type: "land",
        payload
    }
};

export const setStreetAction = (payload) => {
    return {
        type: "street",
        payload
    }
};

export const setNearAction = (payload) => {
    return {
        type: "near",
        payload
    }
};

export const setPlzAction = (payload) => {
    return {
        type: "plz",
        payload
    }
};

export const setOrtAction = (payload) => {
    return {
        type: "ort",
        payload
    }
};

export const setTelephoneAction = (payload) => {
    return {
        type: "telephone",
        payload
    }
};

export const setMessageAction = (payload) => {
    return {
        type: "message",
        payload
    }
};